import { useState } from "react";
import { apiClient, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, Card, Field, inputCls, btnPrimary } from "@/components/admin/ui";

export default function ChangePasswordPage() {
    const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (form.new_password !== form.confirm) {
            toast.error("New passwords do not match");
            return;
        }
        if (form.new_password.length < 8) {
            toast.error("New password must be at least 8 characters");
            return;
        }
        setLoading(true);
        try {
            await apiClient.post("/auth/change-password", {
                current_password: form.current_password,
                new_password: form.new_password,
            });
            toast.success("Password changed.");
            setForm({ current_password: "", new_password: "", confirm: "" });
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <PageHeader title="Change password" subtitle="Pick a new password (minimum 8 characters)." />
            <Card className="p-6 md:p-8 max-w-xl">
                <form onSubmit={submit} className="space-y-5" data-testid="change-password-form">
                    <Field label="Current password" required>
                        <input data-testid="change-current" type="password" required className={inputCls} value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} />
                    </Field>
                    <Field label="New password" required>
                        <input data-testid="change-new" type="password" required minLength={8} className={inputCls} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} />
                    </Field>
                    <Field label="Confirm new password" required>
                        <input data-testid="change-confirm" type="password" required minLength={8} className={inputCls} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
                    </Field>
                    <button data-testid="change-submit" disabled={loading} className={btnPrimary}>Update password</button>
                </form>
            </Card>
        </>
    );
}
